module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/socialProofMenus-e4a3f89d69bd1ee9da678f130ae66501.png";